import {AccountCircleIcon} from '@ui/icons/material/AccountCircle';
import {DriveFileMoveIcon} from '@ui/icons/material/DriveFileMove';
import {SettingsIcon} from '@ui/icons/material/Settings';
import {SvgIconProps} from '@ui/icons/svg-icon';
import {ComponentType} from 'react';

// Keyed by the menu item's own action, so repointing an item drops its icon
// unless the new target is listed here too. Admin Area now goes to /admin, which
// forwards each role to a page it can actually open; /admin/reports stays mapped
// for any install whose menu still carries the old target.
export const authDropdownIcons: Record<string, ComponentType<SvgIconProps>> = {
  '/admin': SettingsIcon,
  '/admin/reports': SettingsIcon,
  '/drive': DriveFileMoveIcon,
  '/account-settings': AccountCircleIcon,
};
